import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';

import {IconButtonTooltipComponent} from '@dcp/configurator';
import {CartSharedModule} from '@spartacus/cart/base/components';
import {ConfigModule, I18nModule} from '@spartacus/core';

import {DcpCheckoutOrderSummaryComponent} from './dcp-checkout-order-summary.component';

import '@sapudex/web-components/dist/Tooltip.js';
import '@ui5/webcomponents/dist/Icon.js';

@NgModule({
  imports: [
    CommonModule,
    CartSharedModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CheckoutOrderSummary: {
          component: DcpCheckoutOrderSummaryComponent,
        },
      },
    }),
    IconButtonTooltipComponent,
    DcpCheckoutOrderSummaryComponent,
  ],
  exports: [DcpCheckoutOrderSummaryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DcpCheckoutOrderSummaryModule {}
